import { useContext } from 'react'

import {
  type BatchImportState,
  BatchImportStateContext,
} from '@Features/data-management/context/BatchImportContext'

function useBatchImportState(): BatchImportState {
  try {
    const context = useContext(BatchImportStateContext)
    return context
  } catch (error) {
    throw new Error(
      'useBatchImportState must be used within a BatchImportProvider',
    )
  }
}

export default useBatchImportState
